import { render, staticRenderFns } from "./QSign.vue?vue&type=template&id=dae64846&"
import script from "./QSign.vue?vue&type=script&lang=js&"
export * from "./QSign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports